import { Component, OnInit } from '@angular/core';
import { RouterLink }          from '@angular/router';
import {environment} from "../../../environments/environment";

@Component({
    selector: 'subscription-needs-confirmation',
    templateUrl: './subscription-needs-confirmation.component.html'
})
export class SubscriptionNeedsConfirmationComponent implements OnInit {
    env = environment;

    constructor() { }

    ngOnInit() {
    }

}
